import { AppointmentCategory, AppointmentType } from "../types";

// Hide appointment types whose category is `block` or `ignore` from pickers,
// unless a hidden type is already selected — keeping it visible avoids breaking
// configurations made before this filter existed.
// When organizationId is provided, also hide types whose organizationIds list
// does not include the given org (empty/absent list means "all orgs").
export function filterAppointmentTypesForPicker<
  T extends Pick<AppointmentType, "appointmentTypeId" | "category" | "organizationIds">
>(
  appointmentTypes: T[],
  selectedIds:
    | ReadonlyArray<string | null | undefined>
    | string
    | null
    | undefined,
  organizationId?: string
): T[] {
  const selected = new Set(
    (Array.isArray(selectedIds) ? selectedIds : [selectedIds]).filter(
      (id): id is string => Boolean(id)
    )
  );
  return appointmentTypes.filter((t) => {
    const isHidden =
      t.category === AppointmentCategory.block ||
      t.category === AppointmentCategory.ignore;
    if (isHidden && !selected.has(t.appointmentTypeId)) return false;
    if (organizationId && t.organizationIds && t.organizationIds.length > 0 && !t.organizationIds.includes(organizationId)) return false;
    return true;
  });
}
